// Pure patch-over-original merge, extracted out of PrimaryInfo so the
// incoterm_id and is_cod/cod_amount/cod_currency_id merges share one
// directly-testable implementation instead of parallel inline ternaries.
// (Extracted to fix a snap-back bug: the incoterm_id merge used to read
// `saleOrderItem.incoterm_id ?? saleOrder.incoterm_id`, which treats an
// explicit "clear incoterm" patch of `null` the same as "untouched" and
// falls back to the stale saleOrder value — while Save still persists the
// `null`, leaving the displayed value out of sync with what was saved.)
//
// `!== undefined`, not `??`: an explicit `null` (or `false`/`0`) written by
// a "clear on toggle-off" / "clear on select" handler must win over the
// original value. `undefined` is the only case that means "field untouched
// by this patch" and falls through to `originalValue`.
export function mergePatchValue<T>(patchValue: T | undefined, originalValue: T): T {
  return patchValue !== undefined ? patchValue : originalValue;
}
